// @flow
import makeSettingsReducer from 'app/common/reducers/settings/makeSettingsReducer'

import config from 'app/config'
export const dataKey = 'dishes' as const

export type Settings = {
  rows: number
  check: boolean
  id: boolean
  nomenclature: boolean
  processingLevel: boolean
  title: boolean
  photo: boolean
  portion: boolean
  unit: boolean
  cost: boolean
  saleType: boolean
  options: boolean
}

export const dishesDefaultState: Settings = {
  rows: config.perPageItems,
  check: true,
  id: true,
  nomenclature: true,
  processingLevel: true,
  title: true,
  photo: true,
  portion: true,
  unit: true,
  cost: true,
  saleType: true,
  options: true,
}

export default makeSettingsReducer(dataKey, dishesDefaultState)
